<template>
  <div>
    <page-header
      icon="mdi-motorbike"
      :title="restaurantName ? toLatin(restaurantName) : $t('delivery')"
      :subtitle="$t('restaurant_meals')"
    >
      <template #actions v-if="!device.isMobile">
        <circle-button
          :loading="loading"
          @click="initialize"
          icon="mdi-refresh"
          color="primary"
          :small="false"
        />
      </template>
    </page-header>

    <page-toolbar :searchable="false" :loading="loading" v-if="!device.isMobile">
      <template #filters>
        <v-col cols="auto" lg="4">
          <date-picker
            v-model="date"
            single-date
            :label="$t('date')"
            :disabled="loading"
            hide-details
            color="white"
          />
        </v-col>
        <v-col cols="auto" lg="5">
          <text-field
            kind="search"
            v-model="search"
            hide-details
            color="white"
            :label="$t('search_meals_placeholder')"
          />
        </v-col>
      </template>
    </page-toolbar>

    <div class="mt-3 px-2">
      <empty-state
        v-if="loading"
        :loading="true"
        :title="$t('loading_data')"
        icon="mdi-food"
      />

      <empty-state
        v-else-if="!filteredMeals || filteredMeals.length === 0"
        :loading="false"
        :title="$t('no_meals_available')"
        :subtitle="$t('no_data_available')"
        icon="mdi-food-off"
      />

      <v-container v-else fluid class="pa-0">
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="4"
            v-for="(meal, index) in filteredMeals"
            :key="index"
          >
            <v-card class="mx-auto h-100">
              <v-img
                height="250"
                :src="
                  meal.image
                    ? galleryUrl(meal.image.name, 'medium', $route.params.id)
                    : './media/img/no-image.webp'
                "
              ></v-img>
              <v-card-title>{{ toLatin(meal.name) }}</v-card-title>
              <v-card-text>
                {{ translate(meal.description) }}
              </v-card-text>
              <v-btn small text class="primary mt-5 mr-1" @click="toggle(meal)">
                <v-icon v-if="meal.is_checked" class="mr-2"
                  >mdi-checkbox-marked-circle</v-icon
                >
                <v-icon v-else class="mr-2">mdi-circle</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-btn
      fixed
      v-if="checked.length"
      bottom
      class="mx-auto"
      width="400"
      color="primary"
      @click="dialog = true"
    >
      {{ $t("confirm") }} {{ checked.length }}
    </v-btn>
    <global-dialog-card v-model="dialog" max-width="400px" title="" hide-actions>
      <v-card :key="inx" v-for="(meal, inx) in checked">
        <v-img
          height="250"
          :src="
            meal.image
              ? galleryUrl(meal.image.name, 'medium', $route.params.id)
              : './media/img/no-image.webp'
          "
        ></v-img>
        <v-card-title>{{ toLatin(meal.name) }}</v-card-title>
      </v-card>
      <circle-button color="primary" icon="mdi-checkbox-marked-circle" @click="buy()" />
    </global-dialog-card>
  </div>
</template>

<script>
import hasSnackbar from "@/mixins/hasSnackbar";
import restaurantService from "@/services/restaurant";
import EmptyState from "@/components/global/EmptyState.vue";
import PageHeader from "@/components/global/PageHeader.vue";
import PageToolbar from "@/components/global/PageToolbar.vue";
export default {
  mixins: [hasSnackbar],
  components: {
    EmptyState,
    PageHeader,
    PageToolbar,
  },
  data: () => ({
    dialog: false,
    search: "",
    idProp: null,
    restaurantName: "",
    meals: [],
    date: new Date().toISOString().substr(0, 10),
    loading: false,
  }),

  created() {
    this.initialize();
  },
  computed: {
    checked() {
      return this.meals.filter((el) => el.is_checked);
    },
    filteredMeals() {
      const query = (this.search || "").toLowerCase().trim();
      if (!query) return this.meals;
      return this.meals.filter((meal) => {
        const name = this.translate(meal.name || "").toLowerCase();
        const description = this.translate(meal.description || "").toLowerCase();
        return name.includes(query) || description.includes(query);
      });
    },
  },
  methods: {
    initialize() {
      this.loading = true;
      restaurantService
        .getDeliveryRestaurantDetails(this.$route.params.id, {
          date: this.date,
          type: 2,
        })
        .then((res) => {
          res.data.meals.forEach((element) => {
            element.is_checked = 0;
          });
          this.meals = res.data.meals;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_restaurant_details"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggle($meal) {
      $meal.is_checked = !$meal.is_checked;
      this.$forceUpdate();
    },
    buy() {
      this.dialog = false;
    },
  },
  watch: {
    date() {
      this.initialize();
    },
  },
};
</script>
